import { AppEnv } from '../interfaces';

const crmBaseUrl = process.env.NEXT_PUBLIC_CRM_BASE_URL;
const crmAppId = process.env.NEXT_PUBLIC_CRM_APP_ID;
export const crmQuotePath = (quoteId: string) =>
  !!crmBaseUrl && !!crmAppId
    ? `${crmBaseUrl}main.aspx?appid=${crmAppId}&pagetype=entityrecord&etn=quote&id=${quoteId}`
    : null;
export const appId = process.env.NEXT_PUBLIC_ID || '';
export const tenantId = process.env.NEXT_PUBLIC_TENANT_ID || '';
export const redirectURL = process.env.NEXT_PUBLIC_REDIRECT_URL || '';
export const loginURL = `https://login.microsoftonline.com/${tenantId}`;
export const msGraphApiRoot = 'https://graph.microsoft.com';
export const disableFactoryOrder = process.env.NEXT_PUBLIC_DISABLE_FACTORY_ORDER;
export const customerId = process.env.NEXT_PUBLIC_DEFAULT_CUSTOMER_ID || '';
export const businessCustomerId = process.env.NEXT_PUBLIC_DEFAULT_BUSINESS_CUSTOMER_ID || '';
export const apimEndpoint = process.env.NEXT_PUBLIC_APIM_URL || null;
const serviceNowBaseUrl = process.env.NEXT_PUBLIC_SERVICENOW_URL || null;
const serviceNowUrlPathSegment = process.env.NEXT_PUBLIC_SERVICENOW_PATH_SEGMENTS || null;
export const serviceNowSupportUrl = `${serviceNowBaseUrl}${serviceNowUrlPathSegment}` || '';
export const appEnv: AppEnv = (process.env.NEXT_PUBLIC_ENV as AppEnv) || null;
export const manualSignFileUploadSizeInMb = process.env.NEXT_PUBLIC_MANUAL_SIGN_FILE_UPLOAD_SIZE_IN_MB || '{}';
export const ecomAppUrl = process.env.NEXT_PUBLIC_ECOM_APP_URL || null;
export const microsoftClarityProjectId = process.env.NEXT_PUBLIC_MICROSOFT_CLARITY_ID || null;
export const nextGatewayGraphQLEndpoint = process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT;
export const salesCommonGraphqlURL = process.env.NEXT_PUBLIC_SALES_COMMON_GRAPHQL_URL;

export const getApimUrl = () => {
  return apimEndpoint;
};

export const getNextGatewayGraphQlUrl = () => {
  if (appEnv === AppEnv.Development) {
    return 'http://next-backend-gateway:4000/graphql';
  }
  return `${getApimUrl()}/graphql`;
};

export const getNextGatewayRestUrl = () => {
  if (appEnv === AppEnv.Development) {
    return 'http://next-backend-gateway:4000/api';
  }
  return getApimUrl();
};

export const getSalesGatewayGraphQlUrl = () => {
  return salesCommonGraphqlURL;
};
